// PageHeader — port of design/v3/Chrome.jsx:89-110.
// 시안 시그니처 1:1 (viewport, title, date, lastUpdated). 우측 slot 은 시안의
// "마지막 갱신 + refresh icon" 이 default; `children` 을 주면 그 자리에 들어간다
// (디자인 시안에 없는 prop 추가 금지 원칙 준수 — actions/right slot 이름 사용 X).

import type { ReactNode } from 'react';
import { Icon } from '../primitives';

export type Viewport = 'desktop' | 'tablet' | 'mobile';

export interface PageHeaderProps {
  viewport?: Viewport;
  title: string;
  date?: string;
  lastUpdated?: string;
  children?: ReactNode;
}

export function PageHeader({
  viewport = 'desktop',
  title,
  date,
  lastUpdated,
  children,
}: PageHeaderProps) {
  return (
    <div
      style={{
        padding: 'var(--page-header-pad)',
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
        minWidth: 0,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: viewport === 'mobile' ? 22 : 28,
            fontWeight: 700,
            color: 'var(--fg-1)',
            letterSpacing: 0,
            lineHeight: 1.2,
          }}
        >
          {title}
          {date && (
            <span
              style={{
                color: 'var(--fg-3)',
                fontWeight: 500,
                fontSize: viewport === 'mobile' ? 16 : 20,
              }}
            >
              {' '}
              · {date}
            </span>
          )}
        </div>
      </div>
      {children !== undefined ? (
        children
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            fontSize: 12,
            color: 'var(--fg-3)',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            maxWidth: '100%',
          }}
        >
          {lastUpdated && (
            <span style={{ whiteSpace: 'nowrap' }}>
              마지막 갱신{' '}
              <span
                style={{
                  color: 'var(--fg-2)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {lastUpdated}
              </span>
            </span>
          )}
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 8,
              border: '1px solid var(--border-base)',
              background: 'var(--bg-surface)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <Icon name="refresh" size={14} color="var(--fg-2)" />
          </div>
        </div>
      )}
    </div>
  );
}
